import AuthPluginBase from '@src/slide/application/no-edit/plugins/auth/base/base/auth-plugin-base';
import {
    CommonTips,
    CommonTipsActionType,
    CommonTipsType,
    i18n,
} from '@src/slide/application/service/edit-extension/edit-extension-export';
import MsgCenter from '@tencent/docs-scenario-components-message-center';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { AuthEventsKeys } from '@src/slide/application/no-edit/plugins/auth/base/auth-events.interface';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

export default class AuthPluginPC extends AuthPluginBase {
    public initPlugin(): void {
        super.initPlugin();

        // 有效期过期
        this.auth.event.on(AuthEventsKeys.AUTH_EXPIRED, () => {
            this.showAuthExpTimeInvalid();
        });
        // 权限被其他端修改
        this.auth.event.on(AuthEventsKeys.AUTH_MODIFIED, () => {
            import('@tencent/dui/lib/components/Snackbar').then((obj) => {
                const Snackbar = obj.default;
                Snackbar.show({
                    message: i18n.t('权限修改成功'),
                    type: 'success',
                    autoClose: true,
                });
            })
                .catch((error) => {
                    window.log.error(`[loadChunk-error]${error}`);
                });
        });

        MsgCenter.setCallback((msg) => {
            if (!msg) return;
            if (msg.code === 10000 // switch
                || msg.code === 10001) { // logout
                tdw({
                    opername: 'doc_account_web',
                    module: 'account_info',
                    action: 'log_expired',
                    // ver6: 需上报监听登录态过期或失效时的错误码
                    ver6: msg.code,
                });
                this.showRefreshByChangeAccount();
            }
        });
    }

    /**
     * 处理弹框更改有效期按钮回调。子类可重写
     * @protected
     */
    protected handleChangeValidTimeAction() {
        this.show();
    }

    /**
     * 处理过期 ，直接弹框
     */
    private showAuthExpTimeInvalid(): void {
        // 创建者逻辑
        if (SlideDataServices.DocInfoManager()?.isOwner) {
            this.showExptimeTipsForOwner();
        } else { // 协作者逻辑
            this.showWillExptimeTips();
        }
    }

    private showWillExptimeTips(): void {
        const commonTipsConfig = {
            message: i18n.t('文档已到期，你将无法继续访问。'),
            commonTipsType: CommonTipsType.INFO,
            actionType: CommonTipsActionType.REFRESH,
        };
        CommonTips.getInstance().show(commonTipsConfig);
    }

    /**
     * 展示弹框
     */
    private showExptimeTipsForOwner() {
        return import('@tencent/dui/lib/components/Snackbar').then((obj) => {
            const SnackbarMobile = obj.default;
            SnackbarMobile.show({
                message: i18n.t('访问链接已过期，对方无法访问。'),
                type: 'info',
                duration: 10000,
                closable: true,
                autoClose: true,
                action: i18n.t('更改有效期'),
                onClickAction: () => {
                    this.handleChangeValidTimeAction();
                    // 数据上报
                    try {
                        if (window.tdwReport) {
                            window.tdwReport({
                                opername: 'doc_access',
                                module: 'page',
                                action: 'change',
                            });
                        }
                    } catch (e) {
                        // empty
                    }
                },
            });
        })
            .catch((error) => {
                window.log.error(`[loadChunk-error]${error}`);
            });
    }

    private showRefreshByChangeAccount(): void {
        const commonTipsConfig = {
            message: i18n.t('帐号信息变化'),
            commonTipsType: CommonTipsType.INFO,
            actionType: CommonTipsActionType.REFRESH,
            closable: true,
        };
        CommonTips.getInstance().show(commonTipsConfig);
    }
}
